import { DocumentNode, gql } from '@apollo/client';

export const DatabaseIconFragmentGql: DocumentNode = gql`
fragment DatabaseIcon on Database {
  __typename
  connectionType
  isCertified
  certificationNote
}
`;
